import React, { useState } from 'react'

// material-ui
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Collapse from '@mui/material/Collapse'

// icons
import Add from '@mui/icons-material/Add'
import Remove from '@mui/icons-material/Remove'

const ExpandRowButton = props => (
  <Button
    sx={{ backgroundColor: 'grey.300', textTransform: 'none' }}
    {...props}
  />
)

const ExpandRow = ({ title, subtitle, children, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen)
  const handleClick = () => setOpen(!open)

  return (
    <>
      <Box pt={1} pb={1}>
        <ExpandRowButton fullWidth onClick={handleClick}>
          <Box px={1} display='flex' alignItems='center'>
            {open ? <Remove /> : <Add />}
          </Box>
          <Box
            p={1}
            textAlign='left'
            lineHeight={1}
            display='flex'
            flexGrow={1}
            alignItems='center'
          >
            {title}
          </Box>
          <Box px={1} display='flex' alignItems='center'>
            {subtitle}
          </Box>
        </ExpandRowButton>
      </Box>
      <Collapse in={open} timeout='auto' unmountOnExit>
        <Box>{children}</Box>
      </Collapse>
    </>
  )
}

export default ExpandRow
